import {useSelectedSpace} from "@src/features/space-home/hooks/use-selected-space";
import {useGetTimedShuttlesHistoryQuery} from "@src/features/timed-shuttles/redux/timed-shuttles-api-old-endpoint";
import {getCurrentDate, isValidDate} from "@src/utils/date-utils";
import React from "react";
import {useSearchParams} from "react-router-dom";


export const SEARCH_PARAMS = Object.freeze({
	// TODO declare type, maybe add constructor and validator and default value provider
	DATE: "date",
});


const PAGE_SIZE = 30;


export function TimedShuttlesByDateScreen() {
	const selectedSpaceInfo = useSelectedSpace()!;
	const [searchParams, setSearchParams] = useSearchParams();
	
	const setSearchParamsHelper = React.useCallback((newDate: string, replace?: boolean) => {
		setSearchParams((prevParams) => {
			const newParams = {...prevParams, [SEARCH_PARAMS.DATE]: newDate};
			return newParams;
		}, {replace: replace});
	}, [setSearchParams]);
	
	const dateParam = searchParams.get(SEARCH_PARAMS.DATE);
	const isInvalidDate = !dateParam || !isValidDate(dateParam);
	const date = isInvalidDate ? getCurrentDate() : dateParam;
	
	React.useEffect(() => {
		if (isInvalidDate) {
			setSearchParamsHelper(date, true);
		}
	}, [setSearchParamsHelper, isInvalidDate, date]);
	
	const [pageNumber, setPageNumber] = React.useState<number>(0); // todo begin from 0 or 1?

	const {data: queryData, ...queryHandle} = useGetTimedShuttlesHistoryQuery({
		spaceId: selectedSpaceInfo.spaceId,
		pageNumber: pageNumber,
		pageSize: PAGE_SIZE,
		date: date
	});
	
	return (
		<p>
			Timed Shuttles on {dateParam}
		</p>
	);
}
